import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const searchData = createAsyncThunk(
  "search/searchTerm",
  async (search) => {
    try {
      let url;
      if (search.type === "search") {
        const query = search.term.split(" ").join("%20");
        url = `https://www.reddit.com/search.json?q=${query}`;
      } else if (search.type === "subReddit") {
        const subReddit = search.term.split("r/").join("");
        url = `https://www.reddit.com/r/${subReddit}.json`;
      }
      const response = await fetch(url);
      const json = await response.json();
      return json;
    } catch (err) {
      return err;
    }
  }
);

const initialState = {
  results: [],
  loading: false,
  error: "",
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(searchData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(searchData.fulfilled, (state, action) => {
      state.loading = false;
      console.log("ya no estoy cargando");
      state.results = [];
      action.payload.data.children.forEach((post) => {
        state.results.push({
          title: post.data.title,
          text: post.data.selftext,
          author: post.data.author,
          numComments: post.data.num_comments,
          score: post.data.score,
          image:
            post.data.preview?.images[0]?.source?.url?.replace(/&amp;/g, "&") ||
            (post.data.thumbnail?.startsWith("http")
              ? post.data.thumbnail
              : false),
          /*WE NEED THIS DATA IF WE WANNA REQUEST THE POST'S DATA (comments)*/
          subReddit: post.data.subreddit,
          postId: post.data.id,
        });
      });
    });
    builder.addCase(searchData.rejected, (state) => {
      state.error = "Error al hacer la solicitud al servidor";
    });
  },
});

//selectors
export const resultsSelector = (state) => state.search.results;
export const loadingSelector = (state) => state.search.loading;
//reducer
export default searchSlice.reducer;
//actions
